var moduleMap = {
	"./report-view-page": () => {
		return Promise.all([__webpack_require__.e(6), __webpack_require__.e(729), __webpack_require__.e(927), __webpack_require__.e(819), __webpack_require__.e(342), __webpack_require__.e(275), __webpack_require__.e(73), __webpack_require__.e(25)]).then(() => (() => ((__webpack_require__(1025)))));
	},
	"./supplier-view-page": () => {
		return Promise.all([__webpack_require__.e(6), __webpack_require__.e(380), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(275), __webpack_require__.e(73), __webpack_require__.e(496), __webpack_require__.e(627), __webpack_require__.e(89)]).then(() => (() => ((__webpack_require__(6089)))));
	},
	"./admin-view-page": () => {
		return Promise.all([__webpack_require__.e(6), __webpack_require__.e(380), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(275), __webpack_require__.e(496), __webpack_require__.e(627), __webpack_require__.e(799)]).then(() => (() => ((__webpack_require__(8799)))));
	},
	"./en/translation": () => {
		return __webpack_require__.e(447).then(() => (() => ((__webpack_require__(2447)))));
	},
	"./ms/translation": () => {
		return __webpack_require__.e(164).then(() => (() => ((__webpack_require__(5164)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});